import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { SessionService } from '../services/session.service';
import { Observable, of } from 'rxjs/index';
import { LogService } from '../services/log.service';
import { AdminService } from '../services/admin.service';
import { SpinnerService } from '../services/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class AdminResolver implements Resolve<any> {
  constructor(
    private session: SessionService,
    private admin: AdminService,
    private log: LogService,
    private spinner: SpinnerService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const user = this.session.getUser();
    if (user.isAdmin) {
      return Observable.create(
        observer => {
          this.spinner.showSpinner();
          this.admin.initialize(() => {
            this.spinner.hideSpinner();
            observer.next(true);
            observer.complete();
          });
        },
        () => {
          this.spinner.hideSpinner();
        }
      );
    } else {
      return of(true);
    }
  }
}
